<div class="order-details-overlay" *ngIf="isOpen" (click)="onClose()">
  <div class="order-details-panel" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="panel-header">
      <div class="header-content">
        <h2 class="panel-title">Order Details</h2>
        <button class="close-button" (click)="onClose()">
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L11 11M1 11L11 1"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>

      <!-- Order ID and Status -->
      <div class="order-info" *ngIf="order">
        <div class="order-id-label">ORDER ID</div>
        <div class="order-id-row">
          <span class="order-id-number">{{ order.orderId || '-' }}</span>
          <span class="status-badge" [ngClass]="getStatusClass(order.status)">
            {{ order.status?.label || '-' }}
          </span>

          <!-- Three-dot menu -->
          <div class="order-actions" *ngIf="canShowActions()">
            <!-- <button class="action-button" (click)="toggleDropdown($event)" [class.active]="showDropdown">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="3" r="1.5" fill="#555A63"/>
                <circle cx="8" cy="8" r="1.5" fill="#555A63"/>
                <circle cx="8" cy="13" r="1.5" fill="#555A63"/>
              </svg>
            </button> -->

            <!-- Dropdown Menu -->
            <!-- <div class="dropdown-menu" *ngIf="showDropdown" (click)="$event.stopPropagation()">
              <div class="dropdown-item" [class.disabled]="!canCancelOrder()" (click)="canCancelOrder() ? onCancelOrder() : null">
                <div class="dropdown-content">
                  <span class="dropdown-text">Cancel Order</span>
                  <svg class="dropdown-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.75 1.75L12.25 12.25" stroke="#DA1E28" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12.25 1.75L1.75 12.25" stroke="#DA1E28" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- Tabs (match customer-tab-view style) -->
    <div class="odm-tab-view">
      <div
        class="tab-arrow tab-arrow-left"
        (click)="scrollTabs('left')"
        [class.hidden]="!canScrollLeft"
      >
        <img
          src="assets/images/sidebar/chevron-left.svg"
          alt="Previous tabs"
          class="arrow-icon arrow-icon-left"
        />
      </div>
      <div
        class="tab-arrow tab-arrow-right"
        (click)="scrollTabs('right')"
        [class.hidden]="!canScrollRight"
      >
        <img
          src="assets/images/customer/chevron-right.svg"
          alt="Next tabs"
          class="arrow-icon arrow-icon-right"
        />
      </div>
      <div class="tab-navigation">
        <div class="tab-list-container" #orderTabListContainer (scroll)="onTabScroll()">
          <div class="tab-list">
            <div
              *ngFor="let tab of tabs; trackBy: trackByIndex"
              class="tab-item"
              [class.active]="activeTab === tab.id"
              (click)="setActiveTab(tab.id)"
            >
              <div class="tab-content">
                <img
                  class="tab-icon"
                  [src]="'assets/images/' + tab.icon + '.png'"
                  [alt]="tab.label"
                />
                <span class="tab-label">{{ tab.label }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Content Area -->
    <div class="panel-content">
      <!-- Order Summary Tab -->
      <div *ngIf="activeTab === 'order-summary' && order" class="content-area">
        <h3 class="content-title">Order Summary</h3>

        <div class="summary-card">
          <!-- Package Header Section -->
          <div class="package-header-section">
            <div class="package-info-row">
              <div class="package-details">
                <div class="package-name">{{ order.washType || '-' }}</div>
              </div>
              <div class="package-price">{{ formatPrice() }}</div>
            </div>
            <div class="order-id-section">
              <span class="order-id-label">ORDER ID</span>
              <span class="order-id-number">{{ order.orderId || '-' }}</span>
            </div>
          </div>

          <div class="divider"></div>

          <!-- Purchase Info Grid -->
          <div class="purchase-info-grid">
            <!-- First Row -->
            <div class="info-row-container">
              <div class="info-column">
                <span class="info-label">DATE OF PURCHASE</span>
                <span class="info-value">{{ formatDate(order.dateTime) || '-' }}</span>
              </div>
              <div class="info-column">
                <span class="info-label">SOURCE</span>
                <span class="info-value">{{ order.source || 'Way.com' }}</span>
              </div>
            </div>

            <!-- Second Row -->
            <div class="info-row-container">
              <div class="info-column">
                <span class="info-label">TRANSACTION TYPE</span>
                <span class="info-value">{{ getTransactionType() || '-' }}</span>
              </div>
              <div class="info-column" *ngIf="isMembershipTransaction()">
                <span class="info-label">WASH COUNT / LIMIT</span>
                <span class="info-value">{{ order.washCount || 'Unlimited (2 redeemed)' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Booking Details Tab -->
      <div *ngIf="activeTab === 'customer-info' && order" class="content-area">
        <h3 class="content-title">Booking Details</h3>

        <div class="booking-details-card">
          <div class="booking-details-content">
            <div class="customer-name">{{ order.customerName || '-' }}</div>
            <div class="booking-info-grid">
              <!-- First Row -->
              <div class="info-row-container">
                <div class="info-column">
                  <span class="info-label">PHONE NUMBER</span>
                  <span class="info-value">{{ order.phone | usaPhoneDisplay: false }}</span>
                </div>
                <div class="info-column">
                  <span class="info-label">EMAIL</span>
                  <span class="info-value">{{ order.email || '-' }}</span>
                </div>
              </div>

              <!-- Second Row -->
              <div class="info-row-container">
                <div class="info-column">
                  <span class="info-label">LOCATION</span>
                  <span class="info-value">{{ order.branch || '-' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Vehicle Details Tab -->
      <div *ngIf="activeTab === 'vehicle-details' && order" class="content-area">
        <ng-container *ngIf="familyPlanVehicles.length > 0; else regularVehicleDetails">
          <!-- Header outside white background -->
          <div class="family-plan-header">
            <h3 class="content-title">Choose Vehicle</h3>
            <button class="add-vehicle-btn" (click)="onAddVehicle()">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 3.33334V12.6667"
                  stroke="#1366FB"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M3.33334 8H12.6667"
                  stroke="#1366FB"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Add Vehicle
            </button>
          </div>

          <!-- White background container -->
          <div class="family-plan-content">
            <div class="family-vehicles-list">
              <app-vehicle-card
                *ngFor="let v of familyPlanVehicles; trackBy: trackByIndex"
                [vehicle]="{
                  id: v.id,
                  name: getVehicleDisplayName(v),
                  licensePlate: v.license_plate,
                  vin: v.vin,
                  isFamilyPlanVehicle: true,
                }"
                [isParentVehicleCard]="true"
                [selectable]="true"
                [selected]="selectedVehicleId === v.id"
                [selectionType]="'radio'"
                [selectionName]="'familyVehicle'"
                [showFamilyPlanStatus]="false"
                [showDeleteButton]="false"
                [useMobileMenu]="true"
                (selectionChange)="selectVehicle(v.id)"
                (editVehicle)="onEditFamilyVehicle(v)"
                (deleteVehicle)="onDeleteFamilyVehicle(v)"
              ></app-vehicle-card>
            </div>

            <div class="family-plan-footer">
              <button type="button" class="btn-cancel" (click)="onCancelFamilyPlan()">
                Cancel
              </button>
              <div class="footer-right">
                <button type="button" class="btn-back" (click)="onBackFamilyPlan()">Back</button>
                <button
                  type="button"
                  class="btn-select"
                  [disabled]="!selectedVehicleId"
                  (click)="onSelectVehicle()"
                >
                  Select Vehicle
                </button>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Regular Vehicle Details -->
        <ng-template #regularVehicleDetails>
          <h3 class="content-title">Vehicle Details</h3>

          <!-- Edit Mode matching Figma design -->
          <div *ngIf="isVehicleEditMode; else vehicleReadOnly" class="vehicle-edit-container">
            <!-- Shimmer Loading State -->
            <div *ngIf="isLoadingVehicleDetails" class="vehicle-edit-content">
              <div class="shimmer-container">
                <!-- First Section: State + License Plate Shimmer -->
                <div class="form-section">
                  <div class="form-row">
                    <div class="form-field">
                      <div class="shimmer-label"></div>
                      <div class="shimmer-input"></div>
                    </div>
                    <div class="form-field">
                      <div class="shimmer-label"></div>
                      <div class="shimmer-input"></div>
                    </div>
                  </div>
                </div>

                <!-- Second Section: Vehicle Details Shimmer -->
                <div class="form-section">
                  <div class="form-row single">
                    <div class="form-group full">
                      <div class="shimmer-label"></div>
                      <div class="shimmer-input"></div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group">
                      <div class="shimmer-label"></div>
                      <div class="shimmer-input"></div>
                    </div>
                    <div class="form-group">
                      <div class="shimmer-label"></div>
                      <div class="shimmer-input"></div>
                    </div>
                  </div>
                  <div class="form-row single">
                    <div class="form-group full">
                      <div class="shimmer-label"></div>
                      <div class="shimmer-input"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Form Content (shown when not loading) -->
            <div *ngIf="!isLoadingVehicleDetails" class="vehicle-edit-content">
              <!-- Form -->
              <form class="vehicle-edit-form" (ngSubmit)="onSaveVehicleEdit()">
                <!-- First Section: State + License Plate -->
                <div class="form-section">
                  <div class="form-row">
                    <!-- State Field -->
                    <div class="form-field">
                      <label class="field-label">State<span class="asterisk">*</span></label>
                      <div class="select-wrapper p-custom-select">
                        <mat-select
                          class="form-select"
                          [(ngModel)]="vehicleForm.state"
                          name="state"
                          placeholder="Select State"
                        >
                          <app-select-search #statesSearch placeholder="Search"></app-select-search>
                          <mat-option
                            *ngFor="
                              let state of states | selectFilter: statesSearch.query : ['name']
                            "
                            [value]="state.code"
                            >{{ state.name }}</mat-option
                          >
                        </mat-select>
                      </div>
                    </div>

                    <!-- License Plate Field -->
                    <div class="form-field">
                      <label class="field-label"
                        >License Plate<span class="asterisk">*</span></label
                      >
                      <div class="input-wrapper">
                        <input
                          type="text"
                          class="form-input"
                          placeholder="Enter license plate"
                          [(ngModel)]="vehicleForm.licensePlate"
                          name="licensePlate"
                        />
                        <button
                          class="fetch-btn"
                          (click)="onFetchVehicleDetails()"
                          [disabled]="!canFetchVehicle || isLoadingVehicle"
                        >
                          <svg
                            *ngIf="!isLoadingVehicle"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              d="M4.17 6.67L15.83 6.67M15.83 6.67L11.67 2.5M15.83 6.67L11.67 10.83"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <div *ngIf="isLoadingVehicle" class="loading-spinner"></div>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Fetch result note -->
                  <div class="fetch-result" *ngIf="vehicleFetchSuccess">
                    <div class="success-icon">
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="7"
                          cy="7"
                          r="6"
                          fill="#079271"
                          stroke="#079271"
                          stroke-width="1"
                        />
                        <path
                          d="M4.5 7L6 8.5L9.5 5"
                          stroke="#FFFFFF"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <span class="fetch-text">Details fetched</span>
                  </div>
                </div>

                <!-- Second Section: Vehicle Details -->
                <div class="form-section">
                  <!-- Vehicle full-width (non-editable after fetch) -->
                  <div class="form-row single">
                    <div class="form-group full">
                      <label class="form-label">Vehicle</label>
                      <input
                        class="form-input"
                        [class.readonly]="hasAttemptedFetch"
                        type="text"
                        [(ngModel)]="vehicleForm.vehicle"
                        name="vehicle"
                        placeholder="Enter vehicle name"
                        [readonly]="hasAttemptedFetch"
                      />
                    </div>
                  </div>

                  <!-- Row: Year + Make (non-editable after fetch) -->
                  <div class="form-row">
                    <div class="form-group">
                      <label class="form-label">Year</label>
                      <input
                        class="form-input"
                        [class.readonly]="hasAttemptedFetch"
                        type="text"
                        [(ngModel)]="vehicleForm.year"
                        name="year"
                        placeholder="Enter year"
                        [readonly]="hasAttemptedFetch"
                      />
                    </div>
                    <div class="form-group">
                      <label class="form-label">Make</label>
                      <input
                        class="form-input"
                        [class.readonly]="hasAttemptedFetch"
                        type="text"
                        [(ngModel)]="vehicleForm.make"
                        name="make"
                        placeholder="Enter make"
                        [readonly]="hasAttemptedFetch"
                      />
                    </div>
                  </div>

                  <!-- Model full-width (non-editable after fetch) -->
                  <div class="form-row single">
                    <div class="form-group full">
                      <label class="form-label">Model</label>
                      <input
                        class="form-input"
                        [class.readonly]="hasAttemptedFetch"
                        type="text"
                        [(ngModel)]="vehicleForm.model"
                        name="model"
                        placeholder="Enter model"
                        [readonly]="hasAttemptedFetch"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <!-- Fixed Footer actions -->
            <div class="vehicle-edit-footer">
              <button type="button" class="btn-cancel" (click)="onCancelVehicleEdit()">
                Cancel
              </button>
              <button
                type="button"
                class="btn-save"
                [disabled]="isSaveDisabled"
                (click)="onSaveVehicleEdit()"
              >
                Save
              </button>
            </div>
          </div>

          <!-- Read-only Mode matching Figma design -->
          <ng-template #vehicleReadOnly>
            <div class="vehicle-details-card">
              <div class="vehicle-details-content">
                <!-- Vehicle Header with Actions -->
                <div class="vehicle-header">
                  <div class="vehicle-name">{{ getVehicleDisplayNameForOrder() }}</div>
                  <div class="vehicle-actions">
                    <!-- Desktop/Tablet: Show edit icon -->
                    <!-- <button class="action-btn edit-btn desktop-edit-btn" (click)="onVehicleEdit()" title="Edit Vehicle">
                      <img src="assets/images/vehicle-details/edit-icon.svg" alt="Edit" width="20" height="20">
                    </button> -->

                    <!-- Mobile: Show three-dot menu -->
                    <div class="mobile-actions">
                      <button
                        class="mobile-menu-btn"
                        (click)="toggleVehicleMobileMenu($event)"
                        [class.active]="showVehicleMobileMenu"
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="8" cy="3" r="1.5" fill="#555A63" />
                          <circle cx="8" cy="8" r="1.5" fill="#555A63" />
                          <circle cx="8" cy="13" r="1.5" fill="#555A63" />
                        </svg>
                      </button>

                      <!-- Mobile Menu Dropdown -->
                      <div
                        class="mobile-menu-dropdown"
                        *ngIf="showVehicleMobileMenu"
                        (click)="$event.stopPropagation()"
                      >
                        <div
                          class="mobile-menu-item"
                          (click)="onVehicleEdit(); showVehicleMobileMenu = false"
                        >
                          <svg
                            class="menu-icon"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.3333 2.00001C11.5084 1.8249 11.7163 1.686 11.9453 1.59128C12.1742 1.49657 12.4191 1.44775 12.6667 1.44775C12.9142 1.44775 13.1591 1.49657 13.3881 1.59128C13.617 1.686 13.8249 1.8249 14 2.00001C14.1751 2.17512 14.314 2.38302 14.4087 2.61197C14.5034 2.84092 14.5522 3.0858 14.5522 3.33334C14.5522 3.58088 14.5034 3.82576 14.4087 4.05471C14.314 4.28366 14.1751 4.49156 14 4.66667L5 13.6667L1.33333 14.6667L2.33333 11L11.3333 2.00001Z"
                              stroke="#555A63"
                              stroke-width="1.33333"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span>Edit</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Vehicle Info Grid -->
                <div class="vehicle-info-grid">
                  <!-- First Row: Two columns side by side -->
                  <div class="info-row-container">
                    <div class="info-column">
                      <span class="info-label">LICENSE PLATE</span>
                      <span class="info-value">{{ order.licensePlate || '-' }}</span>
                    </div>
                    <div class="info-column">
                      <span class="info-label">VIN NUMBER</span>
                      <span class="info-value">{{ order.vinNumber || '-' }}</span>
                    </div>
                  </div>

                  <!-- Second Row: Single column -->
                  <div class="info-row-container single-column">
                    <div class="info-column">
                      <span class="info-label">FAMILY PLAN VEHICLE</span>
                      <span class="info-value">{{ order.isFamilyPlanVehicle ? 'Yes' : 'No' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-template>
      </div>

      <!-- Payment Tab -->
      <div *ngIf="activeTab === 'payment' && order" class="content-area">
        <div class="payment-section">
          <!-- Loading State - Shimmer -->
          <div *ngIf="isLoadingPaymentDetails" class="payment-loading-container">
            <!-- Payment Info Shimmer -->
            <h3 class="content-title">Payment Info</h3>
            <div class="payment-info-shimmer">
              <div class="shimmer-row">
                <div class="shimmer-col">
                  <div class="shimmer-label"></div>
                  <div class="shimmer-card-details">
                    <div class="shimmer-icon"></div>
                    <div class="shimmer-text"></div>
                  </div>
                  <div class="shimmer-text-small"></div>
                </div>
                <div class="shimmer-col">
                  <div class="shimmer-label"></div>
                  <div class="shimmer-text"></div>
                </div>
              </div>
              <div class="shimmer-row">
                <div class="shimmer-field">
                  <div class="shimmer-label"></div>
                  <div class="shimmer-text"></div>
                </div>
                <div class="shimmer-field">
                  <div class="shimmer-label"></div>
                  <div class="shimmer-text"></div>
                </div>
              </div>
            </div>

            <!-- Transaction History Shimmer -->
            <h3 class="content-title transaction-history-heading">Transaction History</h3>
            <div class="transaction-history-shimmer">
              <div class="shimmer-transaction-item">
                <div class="shimmer-text"></div>
                <div class="shimmer-text-small"></div>
              </div>
            </div>
          </div>

          <!-- Payment Info - Only show when card details are available and payment is not pending -->
          <ng-container *ngIf="!isLoadingPaymentDetails && hasCardDetails() && !isPaymentPending()">
            <h3 class="content-title">Payment Info</h3>
            <app-payment-info-card
              [brandIcon]="getCardBrandIcon()"
              [brandName]="getCardBrandName()"
              [cardMask]="getCardMask()"
              [dateTime]="getPaymentDate()"
              [transactionId]="getTransactionId()"
              [billingAddress]="getBillingAddress()"
              [contact]="getContactInfo()"
            >
            </app-payment-info-card>
          </ng-container>

          <!-- Payment Pending Message - Show when payment is pending -->
          <div
            *ngIf="!isLoadingPaymentDetails && isPaymentPending()"
            class="payment-pending-message"
          >
            <h3 class="content-title">Payment</h3>
            <div class="payment-pending-content">
              <p>Payment is pending</p>
            </div>
          </div>

          <!-- Payment Form - Show when payment is pending -->

          <!-- Transaction History - Only show when payment is NOT pending -->
          <h3
            class="content-title transaction-history-heading"
            *ngIf="!isLoadingPaymentDetails && !isPaymentPending()"
          >
            Transaction History
          </h3>
          <div
            class="transaction-history-card"
            *ngIf="!isLoadingPaymentDetails && !isPaymentPending()"
          >
            <!-- Transaction History Items -->
            <ng-container *ngFor="let th of transactionHistories; trackBy: trackByIndex">
              <app-payment-transaction-card
                [date]="formatPaymentDate(th.payment_date)"
                [items]="getTransactionItems(th)"
                [totalAmount]="getTotalAmountPaid(th)"
                [transactionData]="th"
                [downloadable]="false"
                (downloadInvoice)="onDownloadInvoice($event)"
              >
              </app-payment-transaction-card>
            </ng-container>

            <!-- Empty State - No Transaction History (only show if not pending) -->
            <div
              *ngIf="
                transactionHistories.length === 0 && !paymentDetailsError && !isPaymentPending()
              "
              class="no-transaction-history"
            >
              <p>No transaction history</p>
            </div>

            <!-- Error State -->
            <div *ngIf="paymentDetailsError && !isPaymentPending()" class="no-transaction-history">
              <p>Unable to load transaction history</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Cancel Order Modal -->
<app-cancel-order-modal
  [order]="order"
  [isOpen]="showCancelOrderModal"
  (close)="closeCancelOrderModal()"
  (confirm)="onCancelOrderConfirm($event)"
></app-cancel-order-modal>

<!-- Cancellation Success Modal -->
<app-order-cancellation-success-modal
  [isOpen]="showCancellationSuccessModal"
  [refundAmount]="cancellationRefundAmount"
  [isScheduledOrder]="cancellationWasScheduled"
  (close)="onCancellationSuccessClose()"
  (bookAgain)="onCancellationBookAgain()"
></app-order-cancellation-success-modal>

<!-- Payment Link Sent Modal -->
<app-payment-link-sent-modal
  [isOpen]="showPaymentLinkSentModal"
  [phoneNumber]="paymentForm.phoneNumber"
  [isResending]="isCreatingPaymentLink"
  (close)="onPaymentLinkSentModalClose()"
  (cancelPayment)="onCancelPayment()"
  (resendLink)="onResendPaymentLink()"
>
</app-payment-link-sent-modal>

<!-- Payment Success Modal -->
<app-success-modal
  [isVisible]="showPaymentSuccess"
  [data]="successModalData"
  (close)="onPaymentSuccessModalClose()"
  (action)="onPaymentSuccessAction()"
>
</app-success-modal>
